.refreshing-icon {
    composes: loading-icon from './loading-chart.module.css';
    top: 35%;
}
